import { useState, useRef, useEffect } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import trayaLogo from "../../assets/img/prescription_assets/Traya_Logo.jpg";
import { GoogleCircleFilled, MailFilled, PhoneFilled } from "@ant-design/icons";
import moment from "moment";
import useAssignedStore from "./assigned_tickets/store";
import { doctorFooterMap } from "modules/utilities/utility";

const PrescriptionTemplate = ({
  handleClose,
  setCustomPres,
  ticketData,
  setUpdateData,
  setPrescFileName,
  isMiddelwarePresc,
  ...props
}) => {
  const printContentRef = useRef(null);
  const hasDownloadedRef = useRef(false);
  const _ticket = props.ticket;
  const presData = props?.data;
  const downloadButtonRef = useRef(null);
  const { updateImageData } = useAssignedStore();
  const downloadPDF = async () => {
    const printContent = printContentRef.current;
    if (printContent) {
      const canvas = await html2canvas(printContent);
      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });
      pdf.addImage(imgData, "JPEG", 10, 10, 190, 280);
      const pdfBlob = pdf.output("blob");
      const fileName = `${presData[0]?.customer?.first_name}-${presData[0]?.createdAt}.pdf`;
      if (isMiddelwarePresc) {
        setPrescFileName(fileName);
      }
      const pdfFile = new File([pdfBlob], fileName, {
        type: "application/pdf",
      });
      await uploadFile(pdfFile);
      pdf.save(
        `${presData[0]?.customer?.first_name}-${presData[0]?.createdAt}.pdf`
      );
      if (!isMiddelwarePresc) {
        const newUpdateData = {
          ...ticketData,
          prescriptionName: `${presData[0]?.customer?.first_name}-${presData[0]?.createdAt}.pdf`,
          prescriptionStatus: true,
        };
        setUpdateData(newUpdateData);
        setCustomPres(false);
      }
    }
  };
  const uploadFile = async (presFile) => {
    const imageDataArray = [];
    const file = presFile;
    const type = presFile?.type;
    let fileData = new FormData();
    fileData.append("file", file, file.name);
    imageDataArray.push(fileData);
    const uploadImage = imageDataArray?.map(async (item) => {
      return updateImageData(item, _ticket?._id ?? _ticket[0]?._id);
    });
    await Promise.all(uploadImage);
  };
  useEffect(() => {
    try {
      if (!hasDownloadedRef.current && presData?.length > 0) {
        if (Object.keys(presData[0]).length > 0) {
          if (downloadButtonRef?.current) {
            downloadButtonRef.current.click();
            hasDownloadedRef.current = true;
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
    return () => {
      hasDownloadedRef.current = true;
    };
  }, [presData]);

  return (
    <div
      ref={printContentRef}
      id="printContent"
      style={{
        visibility: false,
        zIndex: -4000000,
        width: "210mm",
        minHeight: "297mm",
        padding: "20px",
        boxSizing: "border-box",
        fontFamily: "Nunito Sans, sans-serif",
        fontSize: "10px",
      }}
    >
      {presData.length > 0
        ? presData.map((data, index) => {
            const prescription = data?.prescription;
            let prescriptionData = [];
            let countTotal = 0;
            let notBreak = true;
            const prescriptionLength = prescriptionData.length;

            return (
              <div style={{ pageBreakAfter: "always" }}>
                <header
                  style={{ display: "flex", justifyContent: "space-evenly" }}
                >
                  <div
                    className="logo"
                    style={{ width: "200px", height: "100px" }}
                  >
                    <img
                      src={trayaLogo}
                      alt=""
                      style={{
                        width: "100%",
                        height: "70%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div style={{ paddingLeft: "4%", textAlign: "center" }}>
                    <h1
                      style={{
                        fontFamily: "Nunito Sans, sans-serif",
                        fontSize: "30px",
                        fontWeight: "bold",
                      }}
                    >
                      Tatvartha Health Pvt. Ltd.
                    </h1>
                    <p
                      style={{
                        fontFamily: "Nunito Sans, sans-serif",
                        fontSize: "18px",
                        color: "black",
                      }}
                    >
                      1st Floor, B101 Interface 16 Mindspace Malad West Mumbai,
                      MH-400064
                    </p>
                  </div>
                </header>

                <div
                  // className="border border-2"
                  style={{
                    fontFamily: "Nunito Sans, sans-serif",
                    color: "black",
                    textAlign: "left",
                    fontSize: "14px",
                    fontWeight: "bold",
                    margin: "50px 0",
                  }}
                >
                  <p>
                    Patient Name: {data?.customer?.first_name}
                    {/* <hr style={{ width: "200px", marginRight: 0 }} /> */}
                  </p>
                  <p>
                    Created At: {moment(data?.createdAt).format("DD-MMM-YYYY")}
                    {/* <hr style={{ width: "200px", marginRight: 0 }} /> */}
                  </p>
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "50px",
                      flexWrap: "wrap", // Allow the items to wrap
                    }}
                  >
                    <h2
                      style={{
                        width: "20%",
                        fontWeight: "bold",
                        flexShrink: 0,
                        fontSize: "19px",
                      }}
                    >
                      Medicine
                    </h2>
                    <h2
                      style={{
                        width: "15%",
                        fontSize: "19px",
                        fontWeight: "bold",
                        flexShrink: 0,
                      }}
                    >
                      Dosage
                    </h2>
                    <h2
                      style={{
                        width: "50%",
                        fontWeight: "bold",
                        fontSize: "19px",
                        flexShrink: 0,
                      }}
                    >
                      Comment
                    </h2>
                  </div>
                  {data?.prescription?.map((prescriptionData, index) => {
                    const {
                      dosage,
                      medicine,
                      comment,
                      prescription,
                      test,
                      external,
                    } = prescriptionData;

                    // Check if the current medication is external
                    const isExternal = external === true;

                    // Check if the previous medication was not external
                    const isFirstExternalMedication =
                      isExternal &&
                      (index === 0 || !data?.prescription[index - 1]?.external);

                    // Check if the current medication is not external
                    const isTrayaMedication = !isExternal;

                    // Check if the previous medication was external
                    const isFirstTrayaMedication =
                      isTrayaMedication &&
                      (index === 0 || data?.prescription[index - 1]?.external);

                    // Check if the current medication has a test
                    const hasTest = !!test;

                    // Check if the previous medication did not have a test
                    const isFirstTestMedication =
                      hasTest &&
                      (index === 0 || !data?.prescription[index - 1]?.test);

                    // Define an array to hold JSX elements
                    const elements = [];

                    // Push the medication elements to the array
                    elements.push(
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "10px",
                          flexWrap: "wrap",
                        }}
                      >
                        {isFirstTrayaMedication && (
                          // Render header for Traya medications
                          <p
                            style={{
                              width: "100%",
                              fontSize: "18px",
                              fontFamily: "Nunito Sans, sans-serif",
                              fontWeight: "bold",
                              color: "black",
                              flexShrink: 0,
                              wordWrap: "break-word",
                            }}
                          >
                            Traya medications:
                          </p>
                        )}

                        {isFirstExternalMedication && (
                          // Render header for external medications
                          <p
                            style={{
                              width: "100%",
                              fontSize: "18px",
                              fontFamily: "Nunito Sans, sans-serif",
                              fontWeight: "bold",
                              color: "black",
                              flexShrink: 0,
                              wordWrap: "break-word",
                            }}
                          >
                            External medications:
                          </p>
                        )}

                        {isFirstTestMedication && (
                          // Render header for medications with tests
                          <p
                            style={{
                              width: "100%",
                              fontSize: "18px",
                              fontFamily: "Nunito Sans, sans-serif",
                              fontWeight: "bold",
                              color: "black",
                              flexShrink: 0,
                              wordWrap: "break-word",
                            }}
                          >
                            Prescibed Tests:
                          </p>
                        )}

                        <div style={{display:'flex', flexDirection:'row', justifyContent:"space-between", width:"100%"}}>
                          <div
                            style={{
                              fontSize: "15px",
                              fontFamily: "Nunito Sans, sans-serif",
                              fontWeight: "bold",
                              color: "#58595b",
                              wordWrap: "break-word",
                              flex:1,
                            }}
                            className="text-left text-wrap text-break mx-3"
                          >
                            {medicine ?? prescription}
                          </div>
                          <div
                            style={{
                              fontSize: "15px",
                              fontFamily: "Nunito Sans, sans-serif",
                              fontWeight: "bold",
                              color: "#58595b",
                              wordWrap: "break-word",
                              flex:1, 
                              marginLeft:"20px"
                            }}
                            className="text-right text-break text-wrap mx-3"
                          >
                            {dosage}
                          </div>
                          <div
                            style={{
                              fontSize: "15px",
                              fontFamily: "Nunito Sans, sans-serif",
                              fontWeight: "bold",
                              color: "#58595b",
                              flex: 1.8,
                              overflow: "hidden"
                            }}
                            className="text-break text-wrap text-left mx-3"
                          >
                            {comment}
                          </div>
                        </div>
                        {test && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              width: "85%",
                            }}
                          >
                            <p
                              style={{
                                fontSize: "15px",
                                fontFamily: "Nunito Sans, sans-serif",
                                fontWeight: "bold",
                                color: "#58595b",
                                flexShrink: 0,
                                wordWrap: "break-word",
                              }}
                            >
                              Test: {test}
                            </p>
                          </div>
                        )}
                      </div>
                    );

                    // Push the HR element to the array when one type of medication is complete
                    if (
                      index === data.prescription.length - 1 ||
                      isExternal !== data.prescription[index + 1]?.external ||
                      hasTest !== !!data.prescription[index + 1]?.test
                    ) {
                      elements.push(
                        <hr
                          key={`hr-${index}`}
                          style={{
                            borderColor: "black",
                            borderWidth: "1px",
                            margin: "10px 0",
                            width: "100%",
                          }}
                        />
                      );
                    }

                    return elements;
                  })}
                </div>
              </div>
            );
          })
        : []}
      <div style={{ textAlign: "left", marginTop: "20rem" }}>
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            color: "black",
            marginBottom: "10px",
          }}
        >
          Doctor
        </h3>
        <h4
          style={{
            fontSize: "16px",
            fontWeight: "bold",
            color: "black",
            margin: "5px 0",
          }}
        >
          Name:{" "}
          {presData && presData[0]?.doctor && presData[0]?.doctor[0]?.first_name
            ? presData[0]?.doctor[0]?.first_name
            : props.doctor}
        </h4>
        <div style={{ margin: "10px 0" }}>
          {doctorFooterMap[
            presData &&
            presData[0]?.doctor &&
            presData[0]?.doctor[0]?.first_name
              ? presData[0]?.doctor[0]?.first_name
              : props.doctor
          ] && (
            <img
              src={
                doctorFooterMap[
                  presData &&
                  presData[0]?.doctor &&
                  presData[0]?.doctor[0]?.first_name
                    ? presData[0]?.doctor[0]?.first_name
                    : props.doctor
                ]
              }
              alt="Doctor's Signature"
              style={{
                marginTop: "10px",
              }}
            />
          )}
        </div>
      </div>

      <div>
        <br />
        <br />
        <div
          style={{
            fontFamily: "Nunito Sans, sans-serif",
            color: "black",
            textAlign: "right",
          }}
        >
          <span style={{ fontSize: "20px" }}>www.traya.health</span>{" "}
          <GoogleCircleFilled style={{ fontSize: "20px" }} />
        </div>
        <div
          style={{
            fontFamily: "Nunito Sans, sans-serif",
            color: "black",
            textAlign: "right",
          }}
        >
          <span style={{ fontSize: "20px" }}>customercare@traya.health</span>{" "}
          <MailFilled style={{ fontSize: "20px" }} />
        </div>
        <div
          style={{
            fontFamily: "Nunito Sans, sans-serif",
            color: "black",
            textAlign: "right",
          }}
        >
          <span style={{ fontSize: "20px" }}>+918828006272</span>{" "}
        </div>
      </div>
      <div>
        <button onClick={downloadPDF} ref={downloadButtonRef}></button>
      </div>
    </div>
  );
};

export default PrescriptionTemplate;
